export const contentData = {
  spanish:{
    layout:{
      title:'ASi Viewer',
      navigation:[
        {name:'Clientes',path:'/clients'},
        {name:'Detalles',path:'/clients/details/:id'},
        {name:'Negocios',path:'/clients/details/:id/businesses'},
        {name:'Detalles',path:'/clients/details/:id/businesses/:idbusiness'},
        {name:'Servicio',path:'/clients/details/:id/businesses/:idbusiness/service/:idservice'},
      ],
      menu:[
        {id:0, label:'General'},
        {id:1, label:'Sellos de Facturación'},
        {id:2, label:'Obligaciones Fiscales'},
        {id:3, label:'Logs'}
      ]
    },
    modals:{
      warning_delete_file:{
        title:'¿Estás seguro?',
        message:'¿Realmente quieres eliminar este registro? Este proceso no puede ser revertido',
        cancelButton:'Cancelar',
        deleteButton:'Eliminar'
      },
      edit_service:{
        title:'Editar servicio',
        button:'Guardar',
        cancelButton:'Cancelar'
      }
    },
    basicform:{
      title:'Información Básica',
      button:'Editar',
      nodata:'Sin Registro',
      data:{
        rfc:{
          label:'',
          data:'',
        },
        sat_password:{
          label:'',
          data:'',
        },
        ciec_key:{
          label:'',
          data:''
        }
      },
      content:{
        rfc:{
          label:'RFC'
        },
        sat_password:{
          label:'Contraseña SAT'
        },
        ciec_key:{
          label:'Clave CIEC'
        }
      },
      documents:{
        title:'Documentos',
        header:{title:'Archivos', actions:'Acciones'},
        files:null
      }
    }
  }
}
